import { Component, Input } from '@angular/core';
import { A11yImage } from '../models/card.type';

@Component({
  selector: 'app-information-card[title][description]',
  templateUrl: './information-card.component.html',
  styleUrls: ['./information-card.component.scss']
})
export class InformationCardComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() a11yImages: A11yImage[] | undefined;
}
